import { render, staticRenderFns } from "./RedesignLayout.vue?vue&type=template&id=d3d98e04&scoped=true"
import script from "./RedesignLayout.vue?vue&type=script&lang=js"
export * from "./RedesignLayout.vue?vue&type=script&lang=js"
import style0 from "./RedesignLayout.vue?vue&type=style&index=0&id=d3d98e04&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d98e04",
  null
  
)

export default component.exports